module.exports = __webpack_public_path__ + "static/hero-image.0a325e21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero-image.jpg
// module id = 405
// module chunks = 35783957827783